module.exports = __webpack_public_path__ + "img/DK_DKShield.ba7c6dc5.png";